import React from 'react';
import View from '../components/ChangePassword';
import action from '../actions/changePassword';

export const context = 'changePassword';

const Route = () => <View action={action} context={context} />;

export default Route;
